
import React, { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import './privacy-policy.scss';

const PrivacyPolicy = () => {
  const { t } = useTranslation();




  return (

    <div className="terms-page-container" style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
        <h1>{t('privacy-policy.title')}</h1>
        <p>{t('privacy-policy.last-updated')}</p>
        
        <section className="terms-section">
            <h2>{t('privacy-policy.section1.title')}</h2>
            <p>{t('privacy-policy.section1.content-1')}</p>
            <p>{t('privacy-policy.section1.content-2')}</p>
            <p>{t('privacy-policy.section1.content-3')}</p>
        </section>

        <section className="terms-section">
            <h2>{t('privacy-policy.section2.title')}</h2>
            <p>{t('privacy-policy.section2.content-1')}</p>
            <p>{t('privacy-policy.section2.content-2')}</p>
            <p>{t('privacy-policy.section2.content-3')}</p>
            <p>{t('privacy-policy.section2.content-4')}</p>
        </section>
        <section className="terms-section">
            <h2>{t('privacy-policy.section3.title')}</h2>
            <p>{t('privacy-policy.section3.content-1')}</p>
            <p>{t('privacy-policy.section3.content-2')}</p>
        </section>
        <section className="terms-section">
            <h2>{t('privacy-policy.section4.title')}</h2>
            <p>{t('privacy-policy.section4.content-1')}</p>
            <p>{t('privacy-policy.section4.content-2')}</p>
            <p>{t('privacy-policy.section4.content-3')}</p>
        </section>
        <section className="terms-section">
            <h2>{t('privacy-policy.section5.title')}</h2>
            <p>{t('privacy-policy.section5.content-1')}</p>
            <p>{t('privacy-policy.section5.content-2')}</p>
        </section>
        <section className="terms-section">
            <h2>{t('privacy-policy.section6.title')}</h2>
            <p>{t('privacy-policy.section6.content-1')}</p>
            <p>{t('privacy-policy.section6.content-2')}</p>
            <p>{t('privacy-policy.section6.content-3')}</p>
        </section>
        <section className="terms-section">
            <h2>{t('privacy-policy.section7.title')}</h2>
            <p>{t('privacy-policy.section7.content-1')}</p>
            <p>{t('privacy-policy.section7.content-2')}</p>
        </section>
        <section className="terms-section">
            <h2>{t('privacy-policy.section8.title')}</h2>
            <p>{t('privacy-policy.section8.content-1')}</p>
        </section>
        <section className="terms-section">
            <h2>{t('privacy-policy.section9.title')}</h2>
            <p>{t('privacy-policy.section9.content-1')}</p>
            <p>{t('privacy-policy.section9.content-2')}</p>
            <p>{t('privacy-policy.section9.content-3')}</p>
            <p>{t('privacy-policy.section9.content-4')}</p>
        </section>
        
    </div>
  );
};

export default PrivacyPolicy;